import { Component, OnInit } from '@angular/core';
import { Empty_Suggest_Interface, Suggest_Interface } from 'src/app/Interface/Suggest_Interface';
import { User_Interface } from 'src/app/Interface/User_Interface';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { SuggestService } from 'src/app/Service/Suggest/Suggest.service';
import { UserService } from 'src/app/Service/User/User.service';

@Component({
  selector: 'app-SuggestReport',
  templateUrl: './SuggestReport.component.html',
  styleUrls: ['./SuggestReport.component.scss']
})
export class SuggestReportComponent implements OnInit {

  Token:String=""
  Selected_User_Id:String="0"
  SubmitPeriodDate:String="1"
  page=0

  Procssing:boolean=false



  constructor(
    private User_Service:UserService,
    private Nav_Service:NavService,
    private Suggest_Service:SuggestService,
  ) { }


  DataList_Suggest:Array<Suggest_Interface>=[]
  DataList_Suggest_Option:Array<User_Interface>=[]

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');

    this.Nav_Service.CheckValidPage(this.Token,2204).subscribe(
      data=>{
        this.Read_User_Option()
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }

  Read_User_Option(){
    this.Procssing=true
    this.User_Service.GetRecord(this.Token).subscribe(
      data=>{
        this.DataList_Suggest_Option=data
        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  ReadData_Report(StartSearchDate,EndSearchDate){
    this.Procssing=true
    this.Suggest_Service.GetReport(this.Token,
      StartSearchDate,
      EndSearchDate,
      Number(this.SubmitPeriodDate),
      this.Selected_User_Id).subscribe(
      data=>{
        this.DataList_Suggest=data
        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }


  
  order:string=''
  orderreverse :boolean=true
  ChangeOrder(item:string)
  {
    this.order=item
    this.orderreverse=!this.orderreverse
  }


  //#region  Form

  Data_Seleted_Suggest:Suggest_Interface=Empty_Suggest_Interface()
  Selected_Record_Switcher: string = 'List'
  Set_List_Suggest_View() {
    this.Selected_Record_Switcher = 'List'

  }

  Set_Form_Suggest_View(item:Suggest_Interface,Switcher:string) {
    this.Data_Seleted_Suggest = item
    this.Selected_Record_Switcher = Switcher
  }

  Set_Form_Suggest_View_Add() {
    this.Data_Seleted_Suggest = Empty_Suggest_Interface()
    this.Selected_Record_Switcher = 'Form'
  }

  //#endregion


}
